import React from "react";

const Messeges = () => {


  return (
    <div>

    </div>
  );
};

export default Messeges;
